import { Tab as FluentTab } from "@fluentui/web-components";
/**
 * Tab
 * @summary A Fabric UI Tab component that extends Fluent UI's Tab, providing a tab item for use within a tab list with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-tab disabled>
 *   <span slot="start">Icon</span>
 *   Tab Title
 *   <span slot="end">Close</span>
 * </fabric-tab>
 * ```
 *
 * @attr {boolean} disabled - When true, the control will be immutable by user interaction.
 *
 * @prop {boolean} disabled - When true, the control will be immutable by user interaction.
 *
 * @slot start - Content before the tab content.
 * @slot default - The default slot for tab text or content.
 * @slot end - Content after the tab content.
 *
 * @csspart tab-content - The container for the tab's content.
 * @cssprop --textContent - Controls the tab text content styling.
 *
 * @extends FluentTab
 * @tagname fabric-tab
 * @public
 */
export class Tab extends FluentTab {
}
//# sourceMappingURL=tab.js.map